import { api } from '@services';

import Product, {
  IProductCreateUpdate,
  IProductCreateUpdateApiModel,
} from '@models/Product.model';

interface IRequest {
  productId: string;
}

const showProductsCreateUpdate = async ({
  productId,
}: IRequest): Promise<IProductCreateUpdate> => {
  const { data: products } = await api.get<IProductCreateUpdateApiModel>(
    `/products/createUpdate/${productId}`,
  );

  return Product.fromCreateUpdateApiModel(products);
};

export { showProductsCreateUpdate };
